import { Command, MultiRootEditor } from 'ckeditor5';

export class QualioTableOfContentsCommand extends Command {
  static readonly commandName = 'QualioTableOfContentsCommand';

  execute(): void {
    const editor = this.editor as MultiRootEditor;
    const isTableOfContentsActive = Boolean(
      editor.getData({ rootName: 'table-of-contents' }),
    );

    const trackChangesCommand = editor.commands.get('trackChanges');
    const trackChangesIsEnabled = trackChangesCommand?.value;
    if (trackChangesCommand?.value) {
      trackChangesCommand.execute();
    }

    if (isTableOfContentsActive) {
      editor.model.change((writer: any) => {
        const root = editor.model.document.getRoot('table-of-contents');
        writer.remove(writer.createRangeIn(root));
      });
    } else {
      editor.enableRoot('table-of-contents', 'tableOfContents');
      editor.model.change((writer: any) => {
        const root = editor.model.document.getRoot('table-of-contents');
        const paragraph = writer.createElement('paragraph');
        writer.insertText(
          'Table of Contents',
          { bold: true, fontSize: '22.4px' },
          paragraph,
          0,
        );
        writer.insert(paragraph, root, 0);
        writer.setSelection(paragraph, 'after');
      });
      editor.execute('insertTableOfContents');
      editor.model.change((writer: any) => {
        const root = editor.model.document.getRoot('table-of-contents');
        if (root) {
          const lastChild = root.getChild(root.childCount - 1);
          writer.setSelection(lastChild, 'after');
          editor.execute('pageBreak');
        }
      });

      editor.disableRoot('table-of-contents', 'tableOfContents');
    }
    if (trackChangesIsEnabled) trackChangesCommand?.execute();
  }

  refresh(): void {
    const roots = (this.editor as any).getRootsAttributes();
    this.value = Boolean(roots?.['table-of-contents']);
    this.isEnabled = true;
  }
}
